<template>
    <form @submit.prevent="submit">

        <FormGroup name="email" label="Email">
            <Input name="email"
                   type="email"
                   ref="email"
                   v-model="form.email"
                   required
                   autocomplete="email"/>
        </FormGroup>

        <FormGroup name="password" label="Password">
            <Input name="password"
                   type="password"
                   v-model="form.password"
                   required
                   autocomplete="current-password"/>
        </FormGroup>

        <div class="mb-4">
            <label class="flex items-center">
                <input type="checkbox"
                       class="form-checkbox"
                       v-model="form.remember"
                       true-value="on"
                       false-value="">
                <span class="ml-2 text-sm text-gray-600">Remember me</span>
            </label>
        </div>

       <slot :form="form">
           <div class="flex items-center justify-end mt-4">
               <router-link
                   :to="{name: 'password.request'}"
                   class="underline text-sm text-gray-600 hover:text-gray-900">
                   Forgot your password?
               </router-link>
               <SubmitButton
                   class="ml-4"
                   :submitting="form.processing"
                   :disabled="form.errors.any()">
                   Login
               </SubmitButton>
           </div>
       </slot>
    </form>
</template>

<script>

import FormGroup from "@/Components/Form/FormGroup";
import Input from "@/Components/Form/Input";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "LoginForm",

    data() {
        return {
            form: this.$form({
                email: '',
                password: '',
                remember: ''
            })
        }
    },

    emits: [
        'success'
    ],

    provide() {
        return {
            form: this.form
        };
    },

    components: {
        FormGroup,
        Input,
        SubmitButton,
    },

    methods: {
        focus() {
            this.$refs.email.focus();
        },
        submit() {
            if (this.form.processing) {
                return;
            }

            this.form.post(route('login'))
                .then(() => {
                    this.$emit("success")
                })
                .catch(console.log);
        }
    },

    watch: {
        'form.email'() {
            this.form.errors.clear('email');
            this.form.errors.clear('password');
        },
        'form.password'() {
            this.form.errors.clear('email');
            this.form.errors.clear('password');
        },
    },
}
</script>

